import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type { Node } from "prosemirror-model";

const width = (node: Node) => {
	const columns = node.attrs.colwidth as number[] | null;
	return columns?.[0] ? ` {width=${columns[0]}px}` : "";
};

const tableCellSimple: NodeSerializerSpec = async (state, node) => {
	state.write("|");
	await state.renderInline(node);
	state.write(width(node));
};

export default tableCellSimple;
